import React, { useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { oneCreate, oneUpload, oneMove, moveSelected } from '~data/actions/bookmarks'
import PickerFileDrop from '~co/picker/file/drop'
import { Confirm } from '~co/overlay/dialog'
import links from '~config/links'

export default function BookmarksDropArea({ spaceId = 0, children }) {
    const dispatch = useDispatch()

    const onUploadFile = useCallback(
        async file => {
            if (/\.(html|csv|json|enex)$/i.test(file.name)) {
                const openImport = await Confirm(
                    t.s('importConfirmTitle'),
                    {
                        description: t.s('importConfirmDescription'),
                        ok: t.s('importBookmarks') + '…',
                    }
                )

                if (openImport)
                    window.open(links.app.import)
                return
            }

            return new Promise((res, rej) => {
                dispatch(
                    oneUpload(
                        {
                            collectionId: parseInt(spaceId),
                            file
                        },
                        res,
                        rej
                    )
                )
            })
        },
        [dispatch, spaceId]
    )

    const onDropLink = useCallback(
        link =>
            new Promise((res, rej) => {
                dispatch(
                    oneCreate(
                        {
                            collectionId: parseInt(spaceId),
                            link
                        },
                        res,
                        rej
                    )
                )
            }),
        [dispatch, spaceId]
    )

    const onDropCustom = useCallback(
        ([type, data]) =>
            new Promise((res, rej) => {
                switch (type) {
                    case 'bookmark':
                        dispatch(oneMove(parseInt(data), parseInt(spaceId), res, rej))
                        break

                    case 'selected_bookmarks':
                        dispatch(moveSelected(parseInt(data), parseInt(spaceId), res, rej))
                        break

                    default:
                        res()
                        break
                }
            }),
        [dispatch, spaceId]
    )

    const onDragCustom = useCallback(
        type => type == 'bookmark' || type == 'selected_bookmarks',
        []
    )

    return (
        <PickerFileDrop
            onFile={onUploadFile}
            onLink={onDropLink}
            onCustom={onDropCustom}
            validateCustom={onDragCustom}>
            {children}
        </PickerFileDrop>
    )
}
